const sendTracker = route => {
  const cleanRoute = route.replace(/\/$/, '');
  const gaTest = window.ga;

  if (!gaTest) return;

  // eslint-disable-next-line no-undef
  ga('set', 'page', cleanRoute);

  // eslint-disable-next-line no-undef
  ga('send', 'pageview');
};

export default sendTracker;



// WEBPACK FOOTER //
// ./src/utils/sendTracker.js